import { render, staticRenderFns } from "./ai_prediction.vue?vue&type=template&id=69cbaa72&scoped=true&"
import script from "./ai_prediction.vue?vue&type=script&lang=js&"
export * from "./ai_prediction.vue?vue&type=script&lang=js&"
import style0 from "./ai_prediction.vue?vue&type=style&index=0&id=69cbaa72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cbaa72",
  null
  
)

export default component.exports